import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.manufacturer_ */
export type ManufacturerId = string & { __brand: 'ManufacturerId' }

/** Represents the table public.manufacturer_ */
export default interface ManufacturerTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<ManufacturerId, ManufacturerId, ManufacturerId>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type Manufacturer = Selectable<ManufacturerTable>

export type ManufacturerInitializer = Insertable<ManufacturerTable>

export type ManufacturerMutator = Updateable<ManufacturerTable>

export const manufacturerId = z.string() as unknown as z.Schema<ManufacturerId>

export const manufacturer = z.object({
  id: manufacturerId,
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<Manufacturer>

export const manufacturerInitializer = z.object({
  id: manufacturerId,
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<ManufacturerInitializer>

export const manufacturerMutator = z.object({
  id: manufacturerId.optional(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<ManufacturerMutator>
